var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:['v-contact-widget__icon', 'text-primary']},[_c('v-icon',{attrs:{"width":"20","name":"phone"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }